export default "/assets/measuring-tape.svg";